import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=f270a1f8&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=f270a1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f270a1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f270a1f8')) {
      api.createRecord('f270a1f8', component.options)
    } else {
      api.reload('f270a1f8', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=f270a1f8&scoped=true&", function () {
      api.rerender('f270a1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fGjJ5rKVD3YA/JS/comp/CookieBox.vue"
export default component.exports